import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { AddCompanyComponent } from 'src/app/modules/companies/pages/add-company/add-company.page';
import { CompaniesListComponent } from 'src/app/modules/companies/pages/companies-list/companies-list.page';
import { CompanyDetailComponent } from 'src/app/modules/companies/pages/company-detail/company-detail.page';
import { PhonebookComponent } from 'src/app/modules/companies/pages/phonebook/phonebook.page';
import { ViewCompanyComponent } from 'src/app/modules/companies/pages/view-company/view-company.page';
import { CompaniesSuspendedListComponent } from './pages/companies-suspended-list/companies-suspended-list.page';
import { CompaniesInformativeNoteListComponent } from './pages/companies-informative-note-list/companies-informative-note-list.page';
var ɵ0 = {
    permissions: ['canReadCompaniesList']
}, ɵ1 = {
    permissions: ['canCreateCompanies']
}, ɵ2 = {
    permissions: ['canViewCompany']
}, ɵ3 = {
    permissions: ['canCreateCompanies']
}, ɵ4 = {
    permissions: ['canViewPhonebook']
}, ɵ5 = {
    permissions: ["canReadCompaniesList"]
}, ɵ6 = {
    permissions: ["canReadCompaniesList"]
};
var routes = [
    {
        path: 'list',
        component: CompaniesListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: 'detail/:companyId',
        component: CompanyDetailComponent,
        canActivate: [RoleGuard],
        data: ɵ1,
    },
    {
        path: 'my-company',
        component: ViewCompanyComponent,
        canActivate: [RoleGuard],
        data: ɵ2,
    },
    {
        path: 'add',
        component: AddCompanyComponent,
        canActivate: [RoleGuard],
        data: ɵ3,
    },
    {
        path: 'my-phonebook',
        component: PhonebookComponent,
        canActivate: [RoleGuard],
        data: ɵ4,
    },
    {
        path: "suspended",
        component: CompaniesSuspendedListComponent,
        canActivate: [RoleGuard],
        data: ɵ5
    },
    {
        path: "informative-note",
        component: CompaniesInformativeNoteListComponent,
        canActivate: [RoleGuard],
        data: ɵ6
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var CompaniesRoutingModule = /** @class */ (function () {
    function CompaniesRoutingModule() {
    }
    return CompaniesRoutingModule;
}());
export { CompaniesRoutingModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6 };
